<button [class]="class" (click)="openDialogRequests$.next()">Importer</button>